import { fechaLarga } from "@/lib/fechas";
import { hoyISO } from "@/lib/zona";
import { eur } from "@/lib/gastos";

export const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
const DIAS_SEM = ["domingos", "lunes", "martes", "miércoles", "jueves", "viernes", "sábados"];
const pad = (n) => String(n).padStart(2, "0");
const iso = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;

export const FRECUENCIAS = [
  ["semanal", "Cada semana"], ["mensual", "Cada mes"], ["trimestral", "Cada tres meses"], ["anual", "Cada año"], ["personalizada", "Otra frecuencia"],
];
const MESES_PASO = { mensual: 1, trimestral: 3, semestral: 6, anual: 12 };

// Igual que el servidor: fechas a partir del inicio; días inexistentes pasan al 1 del mes siguiente.
const fechaMes = (y, m, dia) => {
  const ultimo = new Date(Date.UTC(y, m, 0)).getUTCDate();
  if (dia <= ultimo) return iso(y, m, dia);
  const t = new Date(Date.UTC(y, m - 1, ultimo + 1));
  return iso(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
};
const paso = (g) => {
  if (MESES_PASO[g.frecuencia]) return ["meses", MESES_PASO[g.frecuencia]];
  if (g.frecuencia === "semanal") return ["dias", 7];
  const n = Number(g.cada_n) || 1;
  return g.unidad === "meses" ? ["meses", n] : ["dias", n * (g.unidad === "semanas" ? 7 : 1)];
};
export const fechasDesde = (g, desde, cuantas = 2) => {
  if (!g.fecha_inicio) return [];
  const [y, m, d] = g.fecha_inicio.split("-").map(Number);
  const [u, n] = paso(g);
  const out = [];
  for (let k = 0; k < 2000 && out.length < cuantas; k += 1) {
    let f;
    if (u === "dias") { const t = new Date(Date.UTC(y, m - 1, d + k * n)); f = iso(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate()); }
    else { const mm = m - 1 + k * n; f = fechaMes(y + Math.floor(mm / 12), (mm % 12) + 1, Number(g.dia) || d); }
    if (f < g.fecha_inicio) continue;
    if (g.fecha_fin && f > g.fecha_fin) break;
    if (f >= desde) out.push(f);
  }
  return out;
};
export const primerAviso = (g) => fechasDesde(g, hoyISO() > g.fecha_inicio ? hoyISO() : g.fecha_inicio, 1)[0] || null;

const diaSemana = (f) => DIAS_SEM[new Date(`${f}T12:00:00`).getDay()];
const diaMes = (f) => { const [, m, d] = f.split("-").map(Number); return `${d} de ${MESES[m - 1]}`; };
const uni = (g) => ({ dias: ["día", "días"], semanas: ["semana", "semanas"], meses: ["mes", "meses"] }[g.unidad] || ["día", "días"]);

// "el día 7 de cada mes", "cada semana, los viernes"…
export const cadaCuanto = (g) => {
  const dia = Number(g.dia) || (g.fecha_inicio ? Number(g.fecha_inicio.split("-")[2]) : null);
  if (g.frecuencia === "semanal") return g.fecha_inicio ? `cada semana, los ${diaSemana(g.fecha_inicio)}` : "cada semana";
  if (g.frecuencia === "mensual") return `el día ${dia} de cada mes`;
  if (g.frecuencia === "trimestral") return `el día ${dia}, cada tres meses`;
  if (g.frecuencia === "semestral") return `el día ${dia}, cada seis meses`;
  if (g.frecuencia === "anual") return g.fecha_inicio ? `cada año, el ${diaMes(g.fecha_inicio)}` : "cada año";
  const n = Number(g.cada_n) || 1;
  const [s, p] = uni(g);
  return `cada ${n === 1 ? s : `${n} ${p}`}${g.unidad === "meses" && dia ? `, el día ${dia}` : ""}`;
};
const mayus = (t) => t.charAt(0).toUpperCase() + t.slice(1);
export const cadaCuantoTitulo = (g) => mayus(cadaCuanto(g));

export const resumenCuando = (g) => {
  const p = primerAviso(g);
  const fin = g.fecha_fin ? ` Se repetirá hasta el ${fechaLarga(g.fecha_fin)}.` : " Se repetirá hasta que lo detengas.";
  return `Te avisaremos ${cadaCuanto(g)}.${p ? ` El primer aviso será el ${fechaLarga(p)}.` : " Con esas fechas no habría ningún aviso."}${fin}`;
};

export const nombresTxt = (ns) => (ns.length < 2 ? ns[0] || "" : `${ns.slice(0, -1).join(", ")} y ${ns[ns.length - 1]}`);
export const importeTxt = (v) => (v === "" || v == null ? "" : eur(Number(v)));

export const estadoDe = (g) => {
  if (g.estado === "activa") return { id: "curso", label: "En curso", icon: "PlayCircle", cls: "bg-[#E8F0EC] text-[#2E5645]" };
  if (g.estado === "pausada") return { id: "pausado", label: "Pausado", icon: "PauseCircle", cls: "bg-[#FEF3C7] text-[#92400E]" };
  if (g.motivo_fin === "cancelada") return { id: "cancelado", label: "Cancelado", icon: "XCircle", cls: "bg-[#FEE2E2] text-[#991B1B]" };
  return { id: "terminado", label: "Terminado", icon: "CheckCircle2", cls: "bg-[#E5E7EB] text-[#374151]" };
};

// Mensaje sencillo propuesto. En pantalla se muestran [nombre], [importe]…; al guardar pasan a {nombre}…
export const mensajeAuto = (titulo, conImporte) =>
  `Hola [nombre]:\n\nTe escribo para recordarte «${titulo.trim()}»${conImporte ? ", por importe de [importe] €" : ""}, correspondiente a [mes] de [año].\n\nGracias.`;
export const asuntoAuto = (titulo) => `${titulo.trim()} · [mes] [año]`;
const TOK = ["nombre", "importe", "mes", "año", "fecha"];
export const aServidor = (t) => TOK.reduce((acc, k) => acc.replaceAll(`[${k}]`, `{${k}}`), t || "");
export const aPantalla = (t) => TOK.reduce((acc, k) => acc.replaceAll(`{${k}}`, `[${k}]`), t || "");
